import React from 'react';
import '../Register.css'

export const Divider = () => {
  return (
    <div className="dividerContainer">
      <div className="dividerLine" />
      <span className="dividerText">or</span>
      <div className="dividerLine" />
    </div>
  );
};